/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Error } from '../models/Error'
import type { ResponseDukatOrderFile } from '../models/ResponseDukatOrderFile'
import type { ResponseOrderList } from '../models/ResponseOrderList'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class OrderService {
  /**
   * Zwraca listę zleceń dla klienta
   *
   * @returns ResponseOrderList lista zleceń
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getOrderListFromDukat({
    clientId,
    dateFrom,
    dateTo,
    shopId,
    status,
  }: {
    /**
     * identyfikator klienta
     */
    clientId: number
    /**
     * data od której będą zwracane zlecenia
     */
    dateFrom?: string
    /**
     * data do której będą zwracane zlecenia
     */
    dateTo?: string
    /**
     * identyfikator sklepu
     */
    shopId?: number
    /**
     * statusy zleceń
     */
    status?: Array<number>
  }): CancelablePromise<ResponseOrderList | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/order',
      query: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        clientId: clientId,
        shopId: shopId,
        status: status,
      },
    })
  }

  /**
   * Pobiera plik zlecenia
   *
   * @returns ResponseDukatOrderFile plik zlecenia
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getOrderFileFromDukat({
    clientId,
    uniqueId,
    orderId,
  }: {
    /**
     * identyfikator klienta
     */
    clientId: number
    /**
     * unikalny identyfikator pliku
     */
    uniqueId: string
    /**
     * identyfikator zlecenia
     */
    orderId: string
  }): CancelablePromise<ResponseDukatOrderFile | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/order-pdf/{clientId}',
      path: {
        clientId: clientId,
      },
      query: {
        uniqueId: uniqueId,
        orderId: orderId,
      },
    })
  }
}
